/* Storefront preflight. */
(function () {
  var ENDPOINT = "https://app.sugarwords.ai/api/license/verify";
  var CACHE_KEY = "_sw_fr_v";
  var CACHE_TTL_MS = 5 * 60 * 1000;
  var GATE_STYLE_ID = "sw-fr-g";
  var READY_ATTR = "data-ready";
  var PUBLIC_KEYS_SPKI_B64 = [
    "MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAELp5Qt3XZMYeFsHk2bzTOzGpxBAk2V23g7g4nnHzfsjqRDB8ZkesxYhW2xCW64APgPZRGItHRD6lVwGdIOKhfug==",
    // Add additional keys above during rotation. Tokens signed by ANY
    // listed key are accepted. Remove old keys after the rotation
    // window (~30 days) to keep the trust surface narrow.
  ];
  var MARK_HTML =
    '<a href="https://sugarthe.me/products/sugar-theme" target="_blank" rel="noopener" style="display:block;padding:24px 16px;text-align:center;background:#fff;border:1px dashed #999;border-radius:8px;color:#1a1a1a;text-decoration:none;font-family:system-ui,-apple-system,sans-serif;font-size:14px;line-height:1.5;cursor:pointer">This Sugar Theme component requires a valid license. Click to purchase.</a>';

  window.__swOk = true;

  window.__swCheck = function () {
    return window.__swOk !== false;
  };

  window.__swPulse = function (scriptEl) {
    if (window.__swOk !== false) return;
    var e = scriptEl && scriptEl.parentElement;
    while (e && !e.hasAttribute("data-_sf")) e = e.parentElement;
    if (!e) return;
    e.innerHTML = MARK_HTML;
    e.style.cssText = "display:block!important;visibility:visible!important";
  };

  /* ===================================================================
     DEV MODE — LICENSE CHECK DISABLED (temporaire, pour le dev)
     Force __swOk = true et saute toute la vérif signature/réseau pour
     que le thème s'affiche entièrement pendant le développement.
     POUR RÉACTIVER : supprimer ce bloc (jusqu'au marqueur END), ou
     restaurer assets/head-bootstrap.js.licensed-backup.
     =================================================================== */
  window.__swOk = true;
  return;
  /* === END DEV MODE — LICENSE CHECK DISABLED === */

  var globals = window.__sw_fr || {};
  var token = (globals.t || "").trim();
  var shop = (globals.s || "").trim();

  if (document.getElementById(GATE_STYLE_ID)) {
    window.__swOk = false;
    setGateCode(getGateElement(), getInitialCode(token));
    return;
  }

  if (!token || !shop) {
    showGate(token ? "SUGAR-002" : "SUGAR-001");
    return;
  }

  importPublicKeys()
    .then(function (keys) {
      return verifyOffline(token, shop, keys);
    })
    .then(function (offlineCode) {
      if (offlineCode) {
        showGate(offlineCode);
        return;
      }
      var cached = readCache(token, shop);
      if (cached === "valid") return;
      return verifyNetwork(token, shop).then(
        function (result) {
          if (result.valid) {
            writeCache(token, shop, "valid");
            return;
          }
          showGate(result.errorCode || "SUGAR-003");
        },
        function () {},
      );
    })
    .catch(function () {
      var cached = readCache(token, shop);
      if (cached === "valid") return;
      verifyNetwork(token, shop).then(
        function (result) {
          if (result.valid) {
            writeCache(token, shop, "valid");
            return;
          }
          showGate(result.errorCode || "SUGAR-003");
        },
        function () {},
      );
    });

  function importPublicKeys() {
    if (!window.crypto || !window.crypto.subtle) {
      return Promise.reject(new Error("no subtlecrypto"));
    }
    // Per-key fault tolerance: a single malformed entry in the rotation
    // array (typo'd base64, wrong SPKI structure, etc.) must NOT take
    // down the whole offline-verify path. We catch each importKey
    // rejection individually and filter out the failures, then pass the
    // surviving keys to tryKeyAt. If every key is bad, tryKeyAt(0)
    // immediately resolves to false → showGate('SUGAR-002') → fail-
    // closed, same as today's single-key path.
    return Promise.all(
      PUBLIC_KEYS_SPKI_B64.map(function (b64) {
        var spki;
        try {
          spki = base64ToBytes(b64);
        } catch (e) {
          return Promise.resolve(null);
        }
        return window.crypto.subtle
          .importKey(
            "spki",
            spki,
            { name: "ECDSA", namedCurve: "P-256" },
            false,
            ["verify"],
          )
          .catch(function () {
            return null;
          });
      }),
    ).then(function (keys) {
      return keys.filter(function (k) {
        return k !== null;
      });
    });
  }

  // Returns null on success, or a SUGAR-XXX code string on failure.
  // SUGAR-002 = malformed token / bad signature (token itself is bad).
  // SUGAR-003 = signature is good but bound to a different shop. The
  // caller renders these distinctly so the merchant gets actionable
  // guidance — a shop-bound mismatch is recoverable via Transfer, while
  // a malformed token requires a fresh download.
  function verifyOffline(t, s, keys) {
    if (typeof t !== "string" || t.indexOf(".") < 0) {
      return Promise.resolve("SUGAR-002");
    }
    var parts = t.split(".");
    if (parts.length !== 2 || !parts[0] || !parts[1]) {
      return Promise.resolve("SUGAR-002");
    }
    var body = parts[0];
    var sig = parts[1];
    var sigBytes;
    try {
      sigBytes = base64UrlToBytes(sig);
    } catch (e) {
      return Promise.resolve("SUGAR-002");
    }
    if (sigBytes.length !== 64) return Promise.resolve("SUGAR-002");
    var bodyBytes;
    try {
      bodyBytes = new TextEncoder().encode(body);
    } catch (e) {
      return Promise.resolve("SUGAR-002");
    }

    // Parse payload upfront — same payload regardless of which key
    // signed it. If parse fails, the token is structurally bad.
    var parsed;
    try {
      parsed = JSON.parse(new TextDecoder().decode(base64UrlToBytes(body)));
    } catch (e) {
      return Promise.resolve("SUGAR-002");
    }
    if (
      !parsed ||
      typeof parsed.lid !== "string" ||
      typeof parsed.s !== "string" ||
      typeof parsed.iat !== "number" ||
      parsed.v !== 1
    ) {
      return Promise.resolve("SUGAR-002");
    }

    // Try each successfully-imported key in turn. First match wins.
    // (Malformed keys were filtered upstream in importPublicKeys.) A
    // verify-time rejection skips that key and tries the next.
    function tryKeyAt(i) {
      if (i >= keys.length) return Promise.resolve(false);
      return window.crypto.subtle
        .verify(
          { name: "ECDSA", hash: { name: "SHA-256" } },
          keys[i],
          sigBytes,
          bodyBytes,
        )
        .then(function (sigValid) {
          if (sigValid) return true;
          return tryKeyAt(i + 1);
        })
        .catch(function () {
          return tryKeyAt(i + 1);
        });
    }
    return tryKeyAt(0).then(function (sigValid) {
      if (!sigValid) return "SUGAR-002";
      // Signature is good — only NOW can we trust the payload's shop
      // claim. If the bound shop doesn't match this storefront, surface
      // SUGAR-003 (recoverable) instead of SUGAR-002 (token corrupt).
      if (parsed.s.toLowerCase() !== s.toLowerCase()) {
        return "SUGAR-003";
      }
      return null;
    });
  }

  function verifyNetwork(t, s) {
    var url =
      ENDPOINT +
      "?token=" +
      encodeURIComponent(t) +
      "&shop=" +
      encodeURIComponent(s);
    return fetch(url, { credentials: "omit", mode: "cors" }).then(function (
      response,
    ) {
      if (!response.ok) {
        throw new Error("verify failed: " + response.status);
      }
      return response.json();
    });
  }

  function readCache(t, s) {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || parsed.t !== t || parsed.s !== s) return null;
      if (typeof parsed.e !== "number" || parsed.e < Date.now()) return null;
      return parsed.r;
    } catch (e) {
      return null;
    }
  }

  function writeCache(t, s, result) {
    try {
      sessionStorage.setItem(
        CACHE_KEY,
        JSON.stringify({
          t: t,
          s: s,
          r: result,
          e: Date.now() + CACHE_TTL_MS,
        }),
      );
    } catch (e) {}
  }

  function showGate(code) {
    window.__swOk = false;
    if (document.body) {
      document.body.removeAttribute(READY_ATTR);
    }
    var existing = document.getElementById(GATE_STYLE_ID);
    if (!existing) {
      var style = document.createElement("style");
      style.id = GATE_STYLE_ID;
      style.textContent =
        "body > :not(.sw-fr){display:none!important}.sw-fr{display:flex!important}";
      document.head.appendChild(style);
    }
    setGateCode(getGateElement(), code);
  }

  function getGateElement() {
    return document.querySelector(".sw-fr");
  }

  function setGateCode(gate, code) {
    if (!gate || !code) return;
    gate.setAttribute("data-sw-code", code);
    var ref = gate.querySelector(".sw-fr__code");
    if (ref) ref.textContent = code;
  }

  function getInitialCode(t) {
    if (!t) return "SUGAR-001";
    if (t.length < 100) return "SUGAR-002";
    return "SUGAR-003";
  }

  function base64ToBytes(b64) {
    var bin = atob(b64);
    var bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return bytes;
  }

  function base64UrlToBytes(b64u) {
    var b64 = b64u.replace(/-/g, "+").replace(/_/g, "/");
    var pad = b64.length % 4;
    if (pad === 2) b64 += "==";
    else if (pad === 3) b64 += "=";
    else if (pad !== 0) throw new Error("bad b64url padding");
    return base64ToBytes(b64);
  }
})();
